<template>
	<div class="mia-ScopeAndSequenceControl">
		<h3 v-if="showTitle" v-tr="'scopeandsequence_heading'" class="mia-heading" />
		<p v-if="showDescription" v-tr="'scopeandsequence_description'" class="mia-description" />
		<div class="mia-pdfRow">
			<a v-for="(link, subject) of scopeAndSequenceLinks" :key="subject" v-tr="subjectTrKey(subject)"
				target="_blank" :href="link" class="mia-subjectTile"
			/>
		</div>
	</div>
</template>
<script lang="ts">
import { MiaPlaza } from "@/Reinforced.Typings";
import { Component, Prop, toNative, Vue } from "vue-facing-decorator";
import SubjectHelper from "@/utils/SubjectHelper";

@Component
export class ScopeAndSequenceControl extends Vue {
	@Prop({ type: Object, required: true }) scopeAndSequenceLinks!: Record<MiaPlaza.Model.Subject, string>;
	@Prop({ required: false, default: true }) showDescription!: boolean;
	@Prop({ required: false, default: true }) showTitle!: boolean;

	subjectTrKey(subject: MiaPlaza.Model.Subject) {
		return SubjectHelper.GetTrKey(subject as string);
	}
}

export default toNative(ScopeAndSequenceControl);
</script>
<style lang="scss">
.mia-ScopeAndSequenceControl {
	.mia-pdfRow {
		display: flex;
		justify-content: space-between;
		flex-flow: row wrap;

		.mia-subjectTile {
			font-size: theme.$font-size-small;
			color: theme.$mia-color-panel-font-link;
			display: flex;
			flex-basis: calc(100% / 4 - #{theme.$mia-margin-size-small});
			flex-wrap: wrap;
			border: theme.$mia-border-width-panel-small theme.$mia-color-panel-separator solid;
			border-radius: theme.$mia-border-radius-small;
			padding: theme.$mia-padding-panel;
			text-align: center;
			align-items: center;
			justify-content: center;
			margin: theme.$mia-margin-size-small theme.$mia-margin-size-small 0 0;
		}

		@media(max-width: theme.$screen-xs-max) {
			.mia-subjectTile {
				flex-basis: calc(100% / 2 - #{theme.$mia-margin-size-small});
				font-size: theme.$font-size-small;
			}
		}
	}
}
</style>
